const tabs = [
    {
        type: "Image",
        text: "Images",
    },
    {
        type: "Screenshot",
        text: "Screenshots",
    },
    {
        type: "Icon",
        text: "Icons",
    },
    {
        type: "OperatorLogo",
        text: "Operator Logos",
    },
    {
        type: "PaymentLogo",
        text: "Payment Logos",
    },
    {
        type: "SoftwareLogo",
        text: "Software Logos",
    },
    {
        type: "LicenseLogo",
        text: "License Logos",
    },
    {
        type: "Logo",
        text: "Logos (other)",
    },
];

export default { tabs };
